import axios from "axios"
import { API_GET_COUNTS_DATA } from "."

export const getCountsData = async (func, config) => {
    return axios.get(API_GET_COUNTS_DATA, config).then(res => func(res.data.data)).catch(err => {
        console.log(err.response.status)
        if (err.response.status === 401) {
                localStorage.removeItem("adminHandi");
                localStorage.removeItem("adminHandiAuth")
        }
    });
};